module.exports = __webpack_public_path__ + "img/thumbnail-iwt-03.12cb0ccd.webp";